import { FC } from 'react'
import styled from 'styled-components'
import JobCategoryBottomSheet from '@app.feature/jobCategory/screen/JobCategoryBottomSheet'
import FilterField from '../../../components/FilterFieldWrapper'
import JobCategoryButton from './JobCategoryButton'
import { useJobCategoryField } from './JobCategoryField.module'

interface IFJobCategoryFieldProps {
  className?: string
}

const JobCategoryField: FC<IFJobCategoryFieldProps> = ({ className }) => {
  const {
    selectedCategoryIds,
    sheetOpen,
    onButtonClick,
    onSheetSubmit,
    onSheetClose,
  } = useJobCategoryField()

  return (
    <StyledWrapper label="직무 선택" className={className}>
      <JobCategoryButton
        count={selectedCategoryIds.length}
        onClick={onButtonClick}
      />
      <JobCategoryBottomSheet
        onSubmit={onSheetSubmit}
        onClose={onSheetClose}
        open={sheetOpen}
        defaultCategoryIds={selectedCategoryIds.map(({ id }) => id)}
      />
    </StyledWrapper>
  )
}

export default JobCategoryField

const StyledWrapper = styled(FilterField)``
